// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
.user-mgmt-page {
  padding: 1rem 1.25rem 2rem;
  max-width: 100%;
  color: var(--undp-jtf-primary-color);
  font-family: "OpenSans-Regular";
}

.user-mgmt-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e7ebf3;
}

.user-mgmt-title {
  margin: 0 0 0.35rem;
  font: normal normal 700 1.5rem/1.35 "OpenSans-Regular";
  color: var(--undp-jtf-primary-color);
}

.user-mgmt-subtitle {
  margin: 0;
  max-width: 42rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #64748b;
}

.user-mgmt-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.stats-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.85rem;
  border: 1px solid #dbe3f2;
  border-radius: 999px;
  background: #f7faff;
  font-size: 0.8125rem;
}
.stats-chip__label {
  color: #64748b;
}
.stats-chip__value {
  font-weight: 700;
  color: var(--undp-jtf-primary-color);
}
.stats-chip--warning {
  border-color: #fcd34d;
  background: #fffbeb;
}
.stats-chip--warning .stats-chip__value {
  color: #b45309;
}

.user-mgmt-shell {
  margin-top: 0.25rem;
}

.user-mgmt-panel {
  min-height: 120px;
}

.user-mgmt-panel-content {
  display: block;
  width: 100%;
}

.user-mgmt-tab {
  padding-top: 0.25rem;
}

.user-mgmt-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  min-height: 2.5rem;
}

.user-mgmt-toolbar__start,
.user-mgmt-toolbar__end {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.user-mgmt-toolbar__start {
  flex: 1 1 280px;
  min-width: 0;
}

.user-mgmt-toolbar__end {
  flex: 0 1 auto;
  justify-content: flex-end;
}

.user-mgmt-toolbar--single {
  justify-content: flex-start;
}
.user-mgmt-toolbar--single .user-mgmt-toolbar__start {
  flex: 0 1 auto;
}

.user-mgmt-toolbar__field {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.user-mgmt-toolbar__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.user-mgmt-toolbar__label {
  margin: 0;
  font-size: 0.8125rem;
  color: #64748b;
  white-space: nowrap;
  line-height: 1;
}

.user-mgmt-toolbar__page-size {
  display: block;
  width: 5.5rem;
  min-width: 5.5rem;
  flex-shrink: 0;
}

.user-mgmt-toolbar__page-size-input {
  width: 100%;
  height: 2.25rem;
  padding: 0 0.65rem;
  border: 1px solid #dbe3f2;
  border-radius: 8px;
  font-size: 0.875rem;
  line-height: 1.25;
  color: var(--undp-jtf-primary-color);
  background-color: #fff;
  text-align: center;
}
.user-mgmt-toolbar__page-size-input:focus {
  border-color: var(--undp-jtf-primary-color);
  box-shadow: 0 0 0 3px rgba(0, 55, 112, 0.12);
}

.user-mgmt-card {
  position: relative;
  background: #fff;
  border: 1px solid #e7ebf3;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(14, 30, 37, 0.06);
  overflow: hidden;
}

.user-mgmt-local-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2.5rem 1rem;
  color: #64748b;
  font-size: 0.875rem;
}
.user-mgmt-local-loader__spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid #e2e8f0;
  border-top-color: var(--undp-jtf-primary-color, #2563eb);
  border-radius: 50%;
  animation: user-mgmt-spin 0.7s linear infinite;
}

@keyframes user-mgmt-spin {
  to {
    transform: rotate(360deg);
  }
}
.user-mgmt-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.user-mgmt-table {
  width: 100%;
  min-width: 640px;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  color: var(--undp-jtf-primary-color);
}
.user-mgmt-table thead th {
  padding: 0.85rem 0.75rem;
  border: none;
  background: var(--undp-jtf-btn-dark-color);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  white-space: nowrap;
  vertical-align: middle;
}
.user-mgmt-table tbody th,
.user-mgmt-table tbody td {
  padding: 0.65rem 0.75rem;
  border-bottom: 1px solid #eef1f6;
  vertical-align: middle;
  font-size: 0.875rem;
}
.user-mgmt-table tbody tr:last-child th,
.user-mgmt-table tbody tr:last-child td {
  border-bottom: none;
}
.user-mgmt-table tbody tr:hover td,
.user-mgmt-table tbody tr:hover th[scope=row] {
  background: rgba(0, 55, 112, 0.04);
}

.user-mgmt-empty {
  margin: 0;
  padding: 2.5rem 1.5rem;
  text-align: center;
  color: #64748b;
  font-size: 0.9375rem;
}

.user-mgmt-table .user-mgmt-empty {
  padding: 1.5rem;
}

.user-mgmt-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 0.75rem 1rem 1rem;
  border-top: 1px solid #eef1f6;
}

.user-mgmt-actions {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.user-mgmt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 2.25rem;
  min-height: 2.25rem;
  padding: 0.35rem 0.55rem;
  border: 1px solid #dbe3f2;
  border-radius: 8px;
  background: #fff;
  color: var(--undp-jtf-primary-color);
  font-size: 0.8125rem;
  line-height: 1;
  cursor: pointer;
  pointer-events: auto;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.user-mgmt-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #94a3b8;
}
.user-mgmt-btn--primary {
  border-color: var(--undp-jtf-btn-dark-color);
  background: var(--undp-jtf-btn-dark-color);
  color: #fff;
}
.user-mgmt-btn--primary:hover:not(:disabled) {
  filter: brightness(1.05);
  background: var(--undp-jtf-btn-dark-color);
  color: #fff;
}
.user-mgmt-btn--labeled {
  min-width: auto;
  padding-left: 0.75rem;
  padding-right: 0.85rem;
  white-space: nowrap;
}
.user-mgmt-btn--ghost {
  border-color: transparent;
  background: transparent;
}
.user-mgmt-btn--ghost:hover:not(:disabled) {
  background: #f1f5f9;
}
.user-mgmt-btn--danger {
  border-color: #fecaca;
  color: #b91c1c;
}
.user-mgmt-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #f87171;
}
.user-mgmt-btn--link {
  min-height: auto;
  min-width: auto;
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  color: var(--undp-jtf-btn-dark-color);
  font-weight: 600;
  text-decoration: none;
}
.user-mgmt-btn--link:hover:not(:disabled) {
  background: rgba(0, 55, 112, 0.06);
  text-decoration: underline;
}

.user-mgmt-search {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 1 1 16rem;
  min-width: 12rem;
  max-width: 28rem;
}
.user-mgmt-search__input-wrap {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}
.user-mgmt-search__input-wrap .form-control {
  width: 100%;
  height: 2.25rem;
  padding-right: 2.25rem;
  border-radius: 8px;
  border-color: #dbe3f2;
  font-size: 0.875rem;
}
.user-mgmt-search__input-wrap .form-control:focus {
  border-color: var(--undp-jtf-primary-color);
  box-shadow: 0 0 0 3px rgba(0, 55, 112, 0.12);
}
.user-mgmt-search__submit {
  flex-shrink: 0;
  min-width: auto;
  padding-left: 0.85rem;
  padding-right: 0.85rem;
  white-space: nowrap;
}
.user-mgmt-search__clear {
  position: absolute;
  right: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.15rem 0.35rem;
  border: none;
  background: transparent;
  color: #94a3b8;
  line-height: 1;
}
.user-mgmt-search__clear:hover {
  color: var(--undp-jtf-primary-color);
}

@media (max-width: 768px) {
  .user-mgmt-page {
    padding: 0.75rem 0.75rem 1.5rem;
  }
  .user-mgmt-title {
    font-size: 1.25rem;
  }
  .user-mgmt-search {
    min-width: 100%;
    max-width: 100%;
  }
  .user-mgmt-toolbar__start,
  .user-mgmt-toolbar__end {
    flex: 1 1 100%;
    width: 100%;
  }
  .user-mgmt-toolbar__end {
    justify-content: space-between;
  }
  .user-mgmt-search {
    max-width: none;
  }
}
.custom-ui {
  font-family: "OpenSans-Regular";
}

.btn-ui {
  color: var(--undp-jtf-primary-color) !important;
}

.custom-report-input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #000;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/user-management/components/_user-mgmt-shared.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss","webpack://./apps/hybrid-app/src/app/features/user-management/components/roles/roles.component.scss"],"names":[],"mappings":"AAAA;;EAAA;AAAA;;EAAA;ACEA;EACE,0BAAA;EACA,eAAA;EACA,oCAAA;EACA,+BCDqB;ACMvB;;AFFA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,oBAAA;EACA,gCAAA;AEKF;;AFFA;EACE,mBAAA;EACA,sDAAA;EACA,oCAAA;AEKF;;AFFA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AEKF;;AFFA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AEKF;;AFFA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;AEKF;AFHE;EACE,cAAA;AEKJ;AFFE;EACE,gBAAA;EACA,oCAAA;AEIJ;AFDE;EACE,qBAAA;EACA,mBAAA;AEGJ;AFDI;EACE,cAAA;AEGN;;AFEA;EACE,mBAAA;AECF;;AFEA;EACE,iBAAA;AECF;;AFEA;EACE,cAAA;EACA,WAAA;AECF;;AFEA;EACE,oBAAA;AECF;;AFEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AECF;;AFEA;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AECF;;AFEA;EACE,eAAA;EACA,YAAA;AECF;;AFEA;EACE,cAAA;EACA,yBAAA;AECF;;AFEA;EACE,2BAAA;AECF;AFCE;EACE,cAAA;AECJ;;AFGA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AEAF;;AFGA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AEAF;;AFGA;EACE,SAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AEAF;;AFGA;EACE,cAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AEAF;;AFGA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,kBAAA;AEAF;AFEE;EACE,2CAAA;EACA,4CAAA;AEAJ;;AFIA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,gBAAA;AEDF;;AFKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AEFF;AFIE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,wDAAA;EACA,kBAAA;EACA,8CAAA;AEFJ;;AFMA;EACE;IACE,yBAAA;EEHF;AACF;AFMA;EACE,gBAAA;EACA,iCAAA;AEJF;;AFOA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,oCAAA;AEJF;AFME;EACE,wBAAA;EACA,YAAA;EACA,0CAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AEJJ;AFOE;;EAEE,wBAAA;EACA,gCAAA;EACA,sBAAA;EACA,mBAAA;AELJ;AFQE;;EAEE,mBAAA;AENJ;AFSE;;EAEE,kCAAA;AEPJ;;AFWA;EACE,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AERF;;AFWA;EACE,eAAA;AERF;;AFWA;EACE,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;AERF;;AFWA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AERF;;AFWA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kFAAA;AERF;AFUE;EACE,mBAAA;EACA,qBAAA;AERJ;AFWE;EACE,4CAAA;EACA,0CAAA;EACA,WAAA;AETJ;AFWI;EACE,wBAAA;EACA,0CAAA;EACA,WAAA;AETN;AFaE;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AEXJ;AFcE;EACE,yBAAA;EACA,uBAAA;AEZJ;AFcI;EACE,mBAAA;AEZN;AFgBE;EACE,qBAAA;EACA,cAAA;AEdJ;AFgBI;EACE,mBAAA;EACA,qBAAA;AEdN;AFkBE;EACE,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,qBAAA;AEhBJ;AFkBI;EACE,kCAAA;EACA,0BAAA;AEhBN;;AFqBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AElBF;AFoBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;AElBJ;AFoBI;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AElBN;AFoBM;EACE,2CAAA;EACA,4CAAA;AElBR;AFuBE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AErBJ;AFwBE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AEtBJ;AFwBI;EACE,oCAAA;AEtBN;;AF2BA;EACE;IACE,+BAAA;EExBF;EF2BA;IACE,kBAAA;EEzBF;EF4BA;IACE,eAAA;IACA,eAAA;EE1BF;EF6BA;;IAEE,cAAA;IACA,WAAA;EE3BF;EF8BA;IACE,8BAAA;EE5BF;EF+BA;IACE,eAAA;EE7BF;AACF;AA9YA;EACE,+BDCqB;AC+YvB;;AA7YA;EACE,+CAAA;AAgZF;;AA7YA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAgZF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n\n.user-mgmt-page {\n  padding: 1rem 1.25rem 2rem;\n  max-width: 100%;\n  color: var(--undp-jtf-primary-color);\n  font-family: $primary-font-regular;\n}\n\n.user-mgmt-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e7ebf3;\n}\n\n.user-mgmt-title {\n  margin: 0 0 0.35rem;\n  font: normal normal 700 1.5rem/1.35 $primary-font-regular;\n  color: var(--undp-jtf-primary-color);\n}\n\n.user-mgmt-subtitle {\n  margin: 0;\n  max-width: 42rem;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.user-mgmt-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.stats-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.85rem;\n  border: 1px solid #dbe3f2;\n  border-radius: 999px;\n  background: #f7faff;\n  font-size: 0.8125rem;\n\n  &__label {\n    color: #64748b;\n  }\n\n  &__value {\n    font-weight: 700;\n    color: var(--undp-jtf-primary-color);\n  }\n\n  &--warning {\n    border-color: #fcd34d;\n    background: #fffbeb;\n\n    .stats-chip__value {\n      color: #b45309;\n    }\n  }\n}\n\n.user-mgmt-shell {\n  margin-top: 0.25rem;\n}\n\n.user-mgmt-panel {\n  min-height: 120px;\n}\n\n.user-mgmt-panel-content {\n  display: block;\n  width: 100%;\n}\n\n.user-mgmt-tab {\n  padding-top: 0.25rem;\n}\n\n.user-mgmt-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  min-height: 2.5rem;\n}\n\n.user-mgmt-toolbar__start,\n.user-mgmt-toolbar__end {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.user-mgmt-toolbar__start {\n  flex: 1 1 280px;\n  min-width: 0;\n}\n\n.user-mgmt-toolbar__end {\n  flex: 0 1 auto;\n  justify-content: flex-end;\n}\n\n.user-mgmt-toolbar--single {\n  justify-content: flex-start;\n\n  .user-mgmt-toolbar__start {\n    flex: 0 1 auto;\n  }\n}\n\n.user-mgmt-toolbar__field {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.user-mgmt-toolbar__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.user-mgmt-toolbar__label {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: #64748b;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.user-mgmt-toolbar__page-size {\n  display: block;\n  width: 5.5rem;\n  min-width: 5.5rem;\n  flex-shrink: 0;\n}\n\n.user-mgmt-toolbar__page-size-input {\n  width: 100%;\n  height: 2.25rem;\n  padding: 0 0.65rem;\n  border: 1px solid #dbe3f2;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  line-height: 1.25;\n  color: var(--undp-jtf-primary-color);\n  background-color: #fff;\n  text-align: center;\n\n  &:focus {\n    border-color: var(--undp-jtf-primary-color);\n    box-shadow: 0 0 0 3px rgba(0, 55, 112, 0.12);\n  }\n}\n\n.user-mgmt-card {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e7ebf3;\n  border-radius: 14px;\n  box-shadow: 0 2px 12px rgba(14, 30, 37, 0.06);\n  overflow: hidden;\n\n}\n\n.user-mgmt-local-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2.5rem 1rem;\n  color: #64748b;\n  font-size: 0.875rem;\n\n  &__spinner {\n    width: 2rem;\n    height: 2rem;\n    border: 3px solid #e2e8f0;\n    border-top-color: var(--undp-jtf-primary-color, #2563eb);\n    border-radius: 50%;\n    animation: user-mgmt-spin 0.7s linear infinite;\n  }\n}\n\n@keyframes user-mgmt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.user-mgmt-table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.user-mgmt-table {\n  width: 100%;\n  min-width: 640px;\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  color: var(--undp-jtf-primary-color);\n\n  thead th {\n    padding: 0.85rem 0.75rem;\n    border: none;\n    background: var(--undp-jtf-btn-dark-color);\n    color: #fff;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    white-space: nowrap;\n    vertical-align: middle;\n  }\n\n  tbody th,\n  tbody td {\n    padding: 0.65rem 0.75rem;\n    border-bottom: 1px solid #eef1f6;\n    vertical-align: middle;\n    font-size: 0.875rem;\n  }\n\n  tbody tr:last-child th,\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n\n  tbody tr:hover td,\n  tbody tr:hover th[scope='row'] {\n    background: rgba(0, 55, 112, 0.04);\n  }\n}\n\n.user-mgmt-empty {\n  margin: 0;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.9375rem;\n}\n\n.user-mgmt-table .user-mgmt-empty {\n  padding: 1.5rem;\n}\n\n.user-mgmt-pagination {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.75rem 1rem 1rem;\n  border-top: 1px solid #eef1f6;\n}\n\n.user-mgmt-actions {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.user-mgmt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-width: 2.25rem;\n  min-height: 2.25rem;\n  padding: 0.35rem 0.55rem;\n  border: 1px solid #dbe3f2;\n  border-radius: 8px;\n  background: #fff;\n  color: var(--undp-jtf-primary-color);\n  font-size: 0.8125rem;\n  line-height: 1;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n  }\n\n  &--primary {\n    border-color: var(--undp-jtf-btn-dark-color);\n    background: var(--undp-jtf-btn-dark-color);\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      filter: brightness(1.05);\n      background: var(--undp-jtf-btn-dark-color);\n      color: #fff;\n    }\n  }\n\n  &--labeled {\n    min-width: auto;\n    padding-left: 0.75rem;\n    padding-right: 0.85rem;\n    white-space: nowrap;\n  }\n\n  &--ghost {\n    border-color: transparent;\n    background: transparent;\n\n    &:hover:not(:disabled) {\n      background: #f1f5f9;\n    }\n  }\n\n  &--danger {\n    border-color: #fecaca;\n    color: #b91c1c;\n\n    &:hover:not(:disabled) {\n      background: #fef2f2;\n      border-color: #f87171;\n    }\n  }\n\n  &--link {\n    min-height: auto;\n    min-width: auto;\n    padding: 0.25rem 0.5rem;\n    border: none;\n    background: transparent;\n    color: var(--undp-jtf-btn-dark-color);\n    font-weight: 600;\n    text-decoration: none;\n\n    &:hover:not(:disabled) {\n      background: rgba(0, 55, 112, 0.06);\n      text-decoration: underline;\n    }\n  }\n}\n\n.user-mgmt-search {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex: 1 1 16rem;\n  min-width: 12rem;\n  max-width: 28rem;\n\n  &__input-wrap {\n    position: relative;\n    flex: 1 1 auto;\n    min-width: 0;\n\n    .form-control {\n      width: 100%;\n      height: 2.25rem;\n      padding-right: 2.25rem;\n      border-radius: 8px;\n      border-color: #dbe3f2;\n      font-size: 0.875rem;\n\n      &:focus {\n        border-color: var(--undp-jtf-primary-color);\n        box-shadow: 0 0 0 3px rgba(0, 55, 112, 0.12);\n      }\n    }\n  }\n\n  &__submit {\n    flex-shrink: 0;\n    min-width: auto;\n    padding-left: 0.85rem;\n    padding-right: 0.85rem;\n    white-space: nowrap;\n  }\n\n  &__clear {\n    position: absolute;\n    right: 0.35rem;\n    top: 50%;\n    transform: translateY(-50%);\n    padding: 0.15rem 0.35rem;\n    border: none;\n    background: transparent;\n    color: #94a3b8;\n    line-height: 1;\n\n    &:hover {\n      color: var(--undp-jtf-primary-color);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .user-mgmt-page {\n    padding: 0.75rem 0.75rem 1.5rem;\n  }\n\n  .user-mgmt-title {\n    font-size: 1.25rem;\n  }\n\n  .user-mgmt-search {\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  .user-mgmt-toolbar__start,\n  .user-mgmt-toolbar__end {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .user-mgmt-toolbar__end {\n    justify-content: space-between;\n  }\n\n  .user-mgmt-search {\n    max-width: none;\n  }\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n","@import '../../../../../scss/variables';\n@import '../user-mgmt-shared';\n\n.custom-ui {\n  font-family: $primary-font-regular;\n}\n\n.btn-ui {\n  color: var(--undp-jtf-primary-color) !important;\n}\n\n.custom-report-input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: #000;\n  text-align: center;\n  white-space: nowrap;\n  border-radius: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
